import { Decoration } from "react-diff-view"

import * as React from "react"

interface HunkInfoProps {
    hunk: FileDiff.Hunk
}

const HunkInfo = (props: HunkInfoProps): JSX.Element => (
    <Decoration>{props.hunk.content}</Decoration>
)

export default HunkInfo
